import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-icd-tabs',
  templateUrl: './manage-icd-tabs.component.html',
  styleUrls: ['./manage-icd-tabs.component.css']
})
export class ManageIcdTabsComponent implements OnInit {
  tabIndex = 0;
  activatedRouter: string = 'icds'
  constructor() { }

  ngOnInit(): void {
  }

  onTabClick(event) {
    if (event.index == 0) {
      this.tabIndex = 0;
      this.activatedRouter = 'all'
    }
    else if (event.index == 1) {
      this.tabIndex = 1;
      this.activatedRouter = 'shared'
    }
  }
}
